export const COLORS = {
  primary: '--color-primary',
  bg_primary: '--bg-color-primary',
  primaryLight: '--color-primary-light',
  button: '--color-button',
  primaryDark: '--color-primary-dark',
  bg_primaryDark: '--bg-color-primary-dark',
  bg_secondaryDark: '--bg-color-secondary-dark',
  bg_secondaryLight: '--bg-color-secondary-light',
  secondary: '--color-secondary',
  bg_secondary: '--bg-color-secondary',
  success: '--color-success',
  error: '--color-error',
};
